export default __webpack_public_path__ + "static/incompleteHeroMockup-6aab38bbaecfbf75f1b718f2aff08438.png";